import * as React from 'react';
import cx from 'classnames';
import { CnIcon } from '@/components/cn-icon';
import { CnPopover } from '../cn-popover';
export const CnTextEllipsis = (props) => {
    const { style, className, children, showFolder, line, hasTooltip } = props;
    const textRef = React.useRef(null);
    const [isOverflow, setIsOverflow] = React.useState(false);
    const [showAll, setShowAll] = React.useState(false);
    React.useEffect(() => {
        if (!textRef?.current)
            return;
        if (textRef.current.scrollHeight > textRef.current.offsetHeight) {
            setIsOverflow(true);
        }
    }, []);
    const handleToggleFold = () => {
        setShowAll(!showAll);
    };
    const content = (React.createElement("div", { className: cx('cn-ui-m-text-ellipsis', {
            fold: showFolder && isOverflow,
        }) },
        React.createElement("div", { ref: textRef, className: cx([
                className,
                {
                    'cn-ui-m-text-ellipsis-inner': !showAll,
                },
            ]), style: { ...style, WebkitLineClamp: line } }, children),
        showFolder && isOverflow ? (React.createElement("span", { className: "cn-ui-m-text-ellipsis-fold", onClick: handleToggleFold },
            React.createElement(CnIcon, { type: showAll ? 'triangle-up-fill' : 'triangle-down-fill' }))) : null));
    if (hasTooltip && isOverflow) {
        return (React.createElement(CnPopover, { content: children, placement: "top-start", trigger: "click", mode: "dark" }, content));
    }
    return content;
};
CnTextEllipsis.defaultProps = {
    line: 2,
    hasTooltip: true,
    showFolder: false,
};
CnTextEllipsis.displayName = 'CnTextEllipsis';
